export const EXPAND_SIDEBAR = "V3_EXPAND_SIDEBAR";
export const ORIGINAL_SIDEBAR = "V3_ORIGINAL_SIDEBAR";
/** most likely EXPAND_SIDEBAR and ORIGINAL_SIDEBAR will be deprecated in the future
 * in favor of TOGGLE_SIDEBAR, CLOSE_SIDEBAR and OPEN_SIDEBAR
 */
export const TOGGLE_SIDEBAR = "V3_TOGGLE_SIDEBAR";
export const CLOSE_SIDEBAR = "V3_CLOSE_SIDEBAR";
export const OPEN_SIDEBAR = "V3_OPEN_SIDEBAR";
export const CHANGE_PAGE_HEADER_COLOR = "V3_CHANGE_PAGE_HEADER_COLOR";
export const SET_LOGO = "V3_SET_LOGO";

export const SET_LOADING_ROUTE_PLAYBACK ="V3_SET_LOADING_ROUTE_PLAYBACK";
export const UNSET_LOADING_ROUTE_PLAYBACK = "V3_UNSET_LOADING_ROUTE_PLAYBACK";
export const SET_LOADING_FUEL_ANALYSIS_DASHBOARD ="V3_SET_FUEL_ANALYSIS_DASHBOARD";
export const UNSET_LOADING_FUEL_ANALYSIS_DASHBOARD = "V3_UNSET_LOADING_FUEL_ANALYSIS_DASHBOARD";
export const SET_LOADING_GENERAL = "V3_SET_LOADING_GENERAL";
export const UNSET_LOADING_GENERAL = "V3_UNSET_LOADING_GENERAL";
export const SET_LOADING_VEHICLE_REPORT ="V3_SET_LOADING_VEHICLE_REPORT";
export const UNSET_LOADING_VEHICLE_REPORT = "V3_UNSET_LOADING_VEHICLE_REPORT";
export const SET_LOADING_VEHICLE = "V3_SET_LOADING_VEHICLE";
export const UNSET_LOADING_VEHICLE = "V3_UNSET_LOADING_VEHICLE";
export const SET_LOADING_LIVE_TRACK_LINK = 'V3_SET_LOADING_LIVE_TRACK_LINK'
export const UNSET_LOADING_LIVE_TRACK_LINK = 'V3_UNSET_LOADING_LIVE_TRACK_LINK'
export const SET_LOADING_VAM = "V3_SET_LOADING_VAM";
export const UNSET_LOADING_VAM = "V3_UNSET_LOADING_VAM";
export const SET_LOADING_USER = "V3_SET_LOADING_USER";
export const UNSET_LOADING_USER = "V3_UNSET_LOADING_USER";
export const SET_LOADING_HIER_USER = "V3_SET_LOADING_HIER_USER";
export const UNSET_LOADING_HIER_USER = "V3_UNSET_LOADING_HIER_USER";
export const SET_LOADING_REPORT ="V3_SET_LOADING_REPORT";
export const UNSET_LOADING_REPORT = "V3_UNSET_LOADING_REPORT";

export const SET_LOADING_VAM_LINE = 'V3_SET_LOADING_VAM_LINE'
export const UNSET_LOADING_VAM_LINE = 'V3_UNSET_LOADING_VAM_LINE'

export const SET_LOADING_ACTIONS = 'V3SET_LOADING_ACTIONS';
export const UNSET_LOADING_ACTIONS = 'V3UNSET_LOADING EDIT'

export const SET_LOADING_VEHICLE_EVENT = 'V3SET_LOADING_VEHICLE_EVENT';
export const UNSET_LOADING_VEHICLE_EVENT = 'V3UNSET_LOADING_VEHICLE_EVENT'

export const TOGGLE_UPDATE = "V3_TOGGLE_UPDATE";